import {
  addYears,
  differenceInMonths,
  differenceInYears,
  isBefore,
  setYear,
  startOfDay,
} from 'date-fns';

import { parseCalendarDate } from '../date.ts';

/**
 * Defines what qualifies as "upcoming" birthday
 */
//TODO: Should probably be coming from SDG at some point
export const UPCOMING_BIRTHDAY_MONTHS_LOOKBACK = 3;

export const getAgeFromBirthday = (birthDate: string) => {
  const parsed = parseCalendarDate(birthDate);

  if (!parsed) {
    return '';
  }

  return differenceInYears(new Date(), parsed);
};

export const monthsUntilBirthday = (birthDate: string) => {
  const parsed = parseCalendarDate(birthDate);

  if (!parsed) {
    return null;
  }

  const today = startOfDay(new Date());
  let nextBirthday = setYear(parsed, today.getFullYear());

  // If birthday has passed this year, use next year
  if (isBefore(nextBirthday, today)) {
    nextBirthday = addYears(nextBirthday, 1);
  }

  return differenceInMonths(nextBirthday, today) + 1; // +1 to count the current month if we're within it
};
